import styled, { css } from 'styled-components';
import { transparentThemeColour } from '../../common/styles/ThemeColours';
import { ZIndex } from '../../common/styles/constants';
import { OVERLAY_ANIMATION_DURATION } from '../constants';

export const TopLayer = styled.div<{ visible: boolean; transition: boolean; experiment: boolean }>(
  ({ visible, transition, experiment }) =>
    css`
      left: 0;
      position: sticky;
      right: 0;
      top: 0;
      transform: translateY(${visible ? 0 : '-100%'});
      transition: ${transition ? 'transform 0.3s' : 'none'};
      transition-delay: ${experiment ? '0.1s' : '0.3s'};
      z-index: ${ZIndex.NORMAL};
    `,
);

export const ShadeView = styled.div`
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: ${ZIndex.OVERLAY};

  &.enter {
    background-color: transparent;
  }

  &.enter-active {
    background-color: ${transparentThemeColour('black', 0.6)};
    transition: background-color ${OVERLAY_ANIMATION_DURATION}ms;
  }

  &.enter-done {
    background-color: ${transparentThemeColour('black', 0.6)};
  }

  &.exit {
    background-color: ${transparentThemeColour('black', 0.6)};
  }

  &.exit-active {
    background-color: transparent;
    transition: background-color ${OVERLAY_ANIMATION_DURATION}ms;
  }

  &.exit-done {
    background-color: transparent;
  }
`;
